(function () {
  var root = document.getElementById('scent-quiz');
  if (!root) return;

  var wizard = document.getElementById('scent-quiz-wizard');
  var resultPanel = document.getElementById('scent-quiz-result');
  var backBtn = document.getElementById('scent-quiz-back');
  var nextBtn = document.getElementById('scent-quiz-next');
  var retakeBtn = document.getElementById('scent-quiz-retake');
  var steps = Array.prototype.slice.call(root.querySelectorAll('.scent-quiz__step'));
  var progressBars = Array.prototype.slice.call(root.querySelectorAll('.scent-quiz__progress-bar'));

  var TOTAL_STEPS = steps.length;
  var currentStep = 1;
  var answers = { mood: null, room: null, notes: [], season: null };

  var MOOD_TAGS = {
    relaxing: ['relaxing', 'lavender', 'chamomile', 'sage'],
    sweet: ['sugar', 'vanilla', 'raspberry', 'strawberry', 'berries', 'fruity'],
    fresh: ['fresh', 'clean', 'citrus', 'lemon', 'eucalyptus'],
    bold: ['cinnamon', 'clove', 'musk', 'dark musk'],
    cozy: ['amber', 'cedar', 'caramel', 'maple', 'pumpkin', 'vanilla bean', 'cocoa']
  };
  var ROOM_TAGS = {
    bedroom: ['relaxing', 'lavender', 'musk', 'vanilla'],
    bathroom: ['fresh', 'clean', 'citrus', 'eucalyptus'],
    livingroom: ['amber', 'cedar', 'sugar', 'vanilla'],
    kitchen: ['vanilla', 'caramel', 'cinnamon', 'maple', 'sugar'],
    anywhere: []
  };
  var NOTE_TAGS = {
    vanilla: ['vanilla', 'vanilla bean'],
    coconut: ['coconut', 'coconut milk'],
    citrus: ['citrus', 'orange', 'lemon', 'tangerine', 'orange peel', 'cara cara orange'],
    berry: ['raspberry', 'strawberry', 'cranberry', 'tart cranberry', 'black cherry', 'berries', 'mixed berries'],
    musk: ['musk', 'dark musk', 'light musk'],
    lavender: ['lavender', 'chamomile'],
    spice: ['cinnamon', 'clove', 'caramelized sugar'],
    caramel: ['caramel', 'maple', 'pecan'],
    floral: ['jasmine', 'magnolia', 'neroli', 'freesia', 'carnation', 'orange blossom', 'lilly of the valley'],
    woodsy: ['cedar', 'cedarwood', 'sandalwood', 'amber', 'palo santo']
  };
  var SEASON_TAGS = {
    spring: ['spring'],
    summer: ['summer'],
    fall: ['fall'],
    winter: ['winter', 'christmas'],
    yearround: []
  };

  var dataScript = document.getElementById('scent-quiz-data');
  var PRODUCTS = [];
  try {
    PRODUCTS = JSON.parse(dataScript.textContent);
  } catch (e) {
    PRODUCTS = [];
  }

  function normalizeTags(tags) {
    return (tags || []).map(function (t) { return t.toLowerCase(); });
  }

  function updateProgress() {
    progressBars.forEach(function (bar) {
      var step = parseInt(bar.getAttribute('data-step'), 10);
      bar.classList.toggle('is-complete', step < currentStep);
      bar.classList.toggle('is-current', step === currentStep);
    });
  }

  function stepIsAnswered(step) {
    if (step === 1) return !!answers.mood;
    if (step === 2) return !!answers.room;
    if (step === 3) return answers.notes.length > 0;
    if (step === 4) return !!answers.season;
    return false;
  }

  function showStep(step) {
    steps.forEach(function (el) {
      el.hidden = parseInt(el.getAttribute('data-step'), 10) !== step;
    });
    backBtn.disabled = step === 1;
    nextBtn.textContent = step === TOTAL_STEPS ? 'See my match' : 'Next →';
    nextBtn.disabled = !stepIsAnswered(step);
    updateProgress();
  }

  root.querySelectorAll('.scent-quiz__options').forEach(function (group) {
    var groupName = group.getAttribute('data-group');
    var mode = group.getAttribute('data-mode');
    group.querySelectorAll('.scent-quiz__pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var value = pill.getAttribute('data-value');
        if (mode === 'single') {
          group.querySelectorAll('.scent-quiz__pill').forEach(function (p) {
            p.classList.remove('is-selected');
          });
          pill.classList.add('is-selected');
          answers[groupName] = value;
        } else {
          pill.classList.toggle('is-selected');
          var idx = answers.notes.indexOf(value);
          if (pill.classList.contains('is-selected') && idx === -1) {
            answers.notes.push(value);
          } else if (!pill.classList.contains('is-selected') && idx !== -1) {
            answers.notes.splice(idx, 1);
          }
        }
        nextBtn.disabled = !stepIsAnswered(currentStep);
      });
    });
  });

  backBtn.addEventListener('click', function () {
    if (currentStep > 1) {
      currentStep -= 1;
      showStep(currentStep);
    }
  });

  nextBtn.addEventListener('click', function () {
    if (!stepIsAnswered(currentStep)) return;
    if (currentStep < TOTAL_STEPS) {
      currentStep += 1;
      showStep(currentStep);
    } else {
      showResults();
    }
  });

  function scoreProduct(product) {
    var tags = normalizeTags(product.tags);
    var score = 0;
    var matched = [];

    (MOOD_TAGS[answers.mood] || []).forEach(function (t) {
      if (tags.indexOf(t) !== -1) { score += 2; matched.push(t); }
    });
    (ROOM_TAGS[answers.room] || []).forEach(function (t) {
      if (tags.indexOf(t) !== -1) { score += 1; matched.push(t); }
    });
    answers.notes.forEach(function (note) {
      (NOTE_TAGS[note] || []).forEach(function (t) {
        if (tags.indexOf(t) !== -1) { score += 3; matched.push(t); }
      });
    });
    (SEASON_TAGS[answers.season] || []).forEach(function (t) {
      if (tags.indexOf(t) !== -1) { score += 2; matched.push(t); }
    });

    var uniqueMatched = [];
    matched.forEach(function (t) {
      if (uniqueMatched.indexOf(t) === -1) uniqueMatched.push(t);
    });

    return { product: product, score: score, matched: uniqueMatched };
  }

  function titleCase(str) {
    return str.replace(/\w\S*/g, function (t) {
      return t.charAt(0).toUpperCase() + t.substr(1);
    });
  }

  function renderPrimary(entry) {
    var wrap = document.getElementById('scent-quiz-result-primary');
    var tagsHtml = entry.matched.slice(0, 5).map(function (t) {
      return '<span class="scent-quiz__result-tag">' + titleCase(t) + '</span>';
    }).join('');

    wrap.innerHTML =
      '<img class="scent-quiz__result-image" src="' + entry.product.image + '" alt="' + entry.product.title + '" loading="lazy">' +
      '<div class="scent-quiz__result-info">' +
        '<div class="scent-quiz__result-name">' + entry.product.title + '</div>' +
        '<div class="scent-quiz__result-price">' + entry.product.price + '</div>' +
        (tagsHtml ? '<div class="scent-quiz__result-tags">' + tagsHtml + '</div>' : '') +
        '<a class="scent-quiz__result-cta" href="' + entry.product.url + '">Shop this scent</a>' +
      '</div>';
  }

  function renderSecondary(entries) {
    var wrap = document.getElementById('scent-quiz-result-secondary');
    wrap.innerHTML = entries.map(function (entry) {
      return (
        '<a class="scent-quiz__result-mini" href="' + entry.product.url + '">' +
          '<img class="scent-quiz__result-mini-image" src="' + entry.product.image + '" alt="' + entry.product.title + '" loading="lazy">' +
          '<div class="scent-quiz__result-mini-body">' +
            '<div class="scent-quiz__result-mini-name">' + entry.product.title + '</div>' +
            '<div class="scent-quiz__result-mini-price">' + entry.product.price + '</div>' +
          '</div>' +
        '</a>'
      );
    }).join('');
  }

  function showResults() {
    var scored = PRODUCTS.map(scoreProduct).sort(function (a, b) { return b.score - a.score; });
    if (scored.length === 0) return;

    renderPrimary(scored[0]);
    renderSecondary(scored.slice(1, 3));

    wizard.hidden = true;
    resultPanel.hidden = false;
    resultPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function resetQuiz() {
    answers = { mood: null, room: null, notes: [], season: null };
    root.querySelectorAll('.scent-quiz__pill').forEach(function (p) {
      p.classList.remove('is-selected');
    });
    currentStep = 1;
    showStep(currentStep);
    resultPanel.hidden = true;
    wizard.hidden = false;
    wizard.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  retakeBtn.addEventListener('click', resetQuiz);

  showStep(currentStep);
})();
